module.exports = __webpack_public_path__ + "img/a12.a1826a59.jpg";